import React from 'react'
import styles from './styles.module.css'
import SimpleBlockContent from '../../../SimpleBlockContent'
import Img from '../../../Img' // task #67: canonical image component
import Text from '../../../Text'
import { $textPrimary, $textTertiary } from '../../../../styles/colors/semantics'

const cx = (...c) => c.filter(Boolean).join(' ')

function ProductTestimonialsV2({ title, subtitle, racers, racingTeams }) {
  return (
    <div className={styles.wrapper}>
      <div className={styles.contentWrapper}>
        <div className={styles.title}>
          <SimpleBlockContent
            blocks={title.text}
            highlight={title.highlight}
            highlightSx={`color: ${$textTertiary.dark};`}
            noSpace
          />
          <div className={styles.subtitle}>
            <SimpleBlockContent
              blocks={subtitle.text}
              highlight={subtitle.highlight}
              highlightSx={`color: ${$textPrimary.dark};`}
              noSpace
            />
          </div>
        </div>
        <div className={styles.sectionWrapper}>
          <div className={styles.sectionTitle}>
            <Text type="heading-4">Racers</Text>
            <Text type="large">using VRS® Hardware</Text>
          </div>
          <div className={styles.racers}>
            { racers.map(r => renderRacer(r)) }
          </div>
        </div>
        <div className={styles.sectionWrapper}>
          <div className={styles.sectionTitle}>
            <Text type="heading-4">Racing teams</Text>
            <Text type="large">using VRS® Hardware</Text>
          </div>
          <div className={styles.racers}>
            { racingTeams.map((t, i) => <>
              <div className={cx(styles.separator, i === 0 && styles.separatorFirst)}/>
                { renderTeam(t) }
              { i === racingTeams.length - 1 && <div className={styles.separator}/>}
            </>
            ) }
          </div>
        </div>
      </div>
    </div>
  )
}

export const renderRacer = (racer) => {
  return (
    <div className={styles.racer} key={racer.name}>
      <div className={styles.imageWrapper}>
        {/* task #67: descriptor via <Img> */}
        <Img
          image={racer.image}
          alt={racer.name}
          layout="fill"
          objectFit="cover"
        />
      </div>
      <div className={styles.nameAndSocial}>
        <Text type="large">{racer.name}</Text>
        <div className={styles.description}><Text type="regular">{racer.description}</Text></div>
        <div className={styles.socialIcons}>
          {
            racer.socials.map(s => (
              <a className={styles.socialLink} key={s.url} href={s.url} target="_blank" rel="noreferrer" >
                <img className={styles.icon} src={s.icon?.src} alt="social-icon" width={24} height={24}/>
              </a>
            ))
          }
        </div>
      </div>
      {
       racer.quote && (
         <div className={styles.quote}>
           <SimpleBlockContent blocks={racer.quote} noSpace/>
         </div>
       )
      }
    </div>
  )
}

export const renderTeam = (team) => {
  return (
    <div className={styles.team} key={team.name}>
      <div className={styles.nameAndSocial} style={{ gap: '16px' }}>
        <Text type="large">{team.name}</Text>
        <div className={styles.socialIcons}>
          {
            team.socials.map(s => (
              <a className={styles.socialLink} key={s.url} href={s.url} target="_blank" rel="noreferrer" >
                <img className={styles.icon} src={s.icon?.src} alt="social-icon" width={24} height={24}/>
              </a>
            ))
          }
        </div>
      </div>
    </div>
  )
}

export default ProductTestimonialsV2
